export const NEED_TO_REGISTER = 'PYMB_0060';
